
<template>
  <div class="grid-row">
    <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
      <div class="doc-list">
        <div class="doc-element">
          <span>{{$_('youtube_channel').toUpperCase()}}</span>
          <a class="btn-view" target="_blank" :href="youtube_channel">{{$_('view')}}</a>
        </div>
        <div class="doc-element" v-for="(doc, index) in aDoc" :key="index">
          <span>{{doc.filename}}</span>
          <a
            target="_blank"
            :href="`${doc.path}`"
            download
            class="btn-download"
          >{{$_('download_button')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import docService from "@/modules/documentation/services/docService";

export default {
  name: "Documentation",
  data() {
    return {
      aDoc: Array(),
      sBaseUrl: process.env.VUE_APP_API_URL,
      youtube_channel: process.env.VUE_APP_SATAB_YOUTUBE
    };
  },
  created() {
    
    this.aDoc = Array()

    docService
      .getDocument()
      .then(res => {
        this.aDoc = res.data;
      })
      .catch(err => {
        console.error(err);
      });
  }
};
</script>

<style scoped>
.doc-element {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: solid 1px #e9e9e9;
  margin-bottom: 15px;
  transition: all 0.2s;
}
.doc-element span {
  color: #8b8b8b;
}
.doc-element:hover {
  background-color: #e9e9e9;
  cursor: pointer;
}

@media screen and (max-width: 800px){
  .doc-element {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .doc-element a {
    margin-top: 15px;
  }
}

</style>